import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import { Box, Typography } from '@mui/material';

const CountryBarChart = ({ data }) => {
  console.log('Country Chart Data:', data); // Debug log

  // Ensure data is an array and sort by value
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%',
          flexDirection: 'column'
        }}
      >
        <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
          No country data available
        </Typography>
        <Typography variant="body2" sx={{ color: '#999' }}>
          Data count: {data ? data.length : 0}
        </Typography>
      </Box>
    );
  }

  const sortedData = data
    .sort((a, b) => b.value - a.value)
    .slice(0, 8); // Top 8 countries

  return (
    <Box sx={{ width: '600px', height: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart 
          data={sortedData} 
          margin={{ top: 5, right: 10, left: 10, bottom: 100 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis 
            dataKey="country" 
            angle={-45}
            textAnchor="end"
            height={90}
            interval={0}
            fontSize={12}
            tick={{ fill: '#666' }}
            axisLine={{ stroke: '#ccc' }}
            tickLine={{ stroke: '#ccc' }}
          />
          <YAxis 
            allowDecimals={false}
            fontSize={12}
            tick={{ fill: '#666' }}
            axisLine={{ stroke: '#ccc' }}
            tickLine={{ stroke: '#ccc' }}
            domain={[0, 'dataMax']}
          />
          <Tooltip 
            formatter={(value) => [value, 'Requests']}
            labelFormatter={(label) => `Country: ${label}`}
            contentStyle={{ 
              backgroundColor: '#fff', 
              border: '2px solid #003781',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}
            labelStyle={{ fontWeight: 'bold', color: '#003781' }}
          />
          <Legend />
          <Bar 
            dataKey="value" 
            fill="#003781"
            radius={[6, 6, 0, 0]}
            name="Number of Requests"
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default CountryBarChart;